module.exports = __webpack_public_path__ + "static/media/tidak_hadir.3dada871.svg";